export default __webpack_public_path__ + "static/media/close_filled.1187e229.svg";